export default {
  'inventory.tab.platform_inventory': 'Platform Inventory',
  'inventory.tab.platform_inventory_tooltips': 'Platform Inventory',
  'inventory.tab.interface_inventory': 'Inventory (SAP Feedback)',
  'inventory.tab.interface_inventory_tooltips': 'Inventory (SAP Feedback)',
  "inventories.on_hand_stock": "Total Qty",
  "inventories.can_order_stock": "Available Qty",
  "inventories.ordered_stock": "Handle Qty",
  "inventories.picking_stock": "Picking Qty",
  "inventories.picked_stock": "Packed Qty",
  'inventories.sap_date_at': 'SAP Date At',
  "inventories.interface.qty": "Qty",
  "inventories.interface.date": "Date",
  "inventories.interface.error": "Error",
  "inventories.interface.status": "Status",
  'inventories.button.sync-stock-to-platform':'Sync To Plaform',
  'inventories.request.sync-stock-to-platform-confirm': 'Are you sure to sync this SKU {sku} to External platform {platform}?',
  'inventories.action-msg.sync-stock-to-platform-success': 'Sync platform stock successful',
};
